import { Permission } from '@/domain/permissions';
import NotAllowedPage from '@/pages/403';
import { HomeOutlined, SettingOutlined, TeamOutlined, WifiOutlined } from '@ant-design/icons';
import { lazy, type FC } from 'react';

const LoginPage = lazy(() => import('@/pages/login/LoginPage'));
const DashboardPage = lazy(() => import('@/pages/dashboard/DashboardPage'));
const PropertyInformationPage = lazy(
  () => import('@/pages/property-information/PropertyInformationPage'),
);
const PropertySettingsPage = lazy(() => import('@/pages/property-settings/PropertySettingsPage'));
const UserSettingsPage = lazy(() => import('@/pages/user-settings/UserSettingsPage'));
const UserDetailsPage = lazy(() => import('@/pages/users/UserDetailsPage'));
const SecurityLayout = lazy(() => import('@/components/SecurityLayout/SecurityLayout'));

export type PropifyRoute = {
  path: string;
  component?: Function;
  children?: PropifyRoute[];
  redirect?: string;
  permissions?: Permission[];
  // For more props see: https://umijs.org/en-US/docs/max/layout-menu
  props?: {
    name?: string;
    icon?: FC<{ className?: string }>;
    hideInMenu?: boolean;
    path?: string;
    target?: '_blank';
    [key: string]: unknown;
  };
};

export const routes: PropifyRoute[] = [
  {
    path: '/login',
    component: LoginPage,
    props: {
      hideInMenu: true,
    },
  },
  {
    path: '/',
    component: SecurityLayout,
    props: {
      hideInMenu: true,
    },
    children: [
      {
        path: '/',
        redirect: '/dashboard',
        props: {
          hideInMenu: true,
        },
      },
      {
        path: '/dashboard',
        component: DashboardPage,
        props: {
          name: 'Live Dashboard',
          icon: WifiOutlined,
        },
      },
      {
        path: '/property-information',
        component: PropertyInformationPage,
        props: {
          name: 'Property Info.',
          icon: HomeOutlined,
        },
      },
      {
        path: '/property-settings',
        component: PropertySettingsPage,
        permissions: [Permission.UPDATE_PROPERTY],
        props: {
          name: 'Property Settings',
          icon: SettingOutlined,
        },
      },
      {
        path: '/user-settings',
        component: UserSettingsPage,
        permissions: [Permission.READ_CALL_CENTER_AGENT_INFORMATION_OTHER_ACCOUNT],
        props: {
          name: 'User Settings',
          icon: TeamOutlined,
        },
      },
      {
        path: '/users/:id',
        component: UserDetailsPage,
        props: {
          name: 'User Details',
          hideInMenu: true,
        },
      },
      {
        path: '/me',
        component: UserDetailsPage,
        props: {
          name: 'User Details',
          hideInMenu: true,
        },
      },
    ],
  },
];

export const unauthorizedRoute: Omit<PropifyRoute, 'path'> = {
  component: NotAllowedPage,
  props: {
    hideInMenu: true,
  },
};
